<template>
  <footer class="footer">
    <div class="footer-grid">
      <!-- Column 1: Brand -->
      <div class="footer-column">
        <router-link to="/"
          ><img
            src="@/assets/pic/logo.png"
            alt="YumEat Logo"
            class="footer-logo-img"
        /></router-link>
        <p>
          With our excellent collection, you can take your lifestyle to the next
          level.
        </p>
        <div class="social-icons">
          <a href="#" aria-label="Facebook"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a href="#" aria-label="Instagram"
            ><i class="fab fa-instagram"></i
          ></a>
          <a href="#" aria-label="WhatsApp"><i class="fab fa-whatsapp"></i></a>
          <a href="mailto:info@yumeat.com" aria-label="Email"
            ><i class="fas fa-envelope"></i
          ></a>
          <a href="tel:+1234567890" aria-label="Phone"
            ><i class="fas fa-phone"></i
          ></a>
        </div>
      </div>

      <!-- Column 2: Company -->
      <div class="footer-column">
        <h4>Company</h4>
        <ul>
          <li><a href="#">Customer Service</a></li>
          <li><a href="#">Career</a></li>
          <li><a href="#">About Us</a></li>
          <li><a href="#">FAQ</a></li>
        </ul>
      </div>

      <!-- Column 3: Support -->
      <div class="footer-column">
        <h4>Support</h4>
        <ul>
          <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
          <li><a href="#">Terms & Condition</a></li>
          <li><a href="#">License</a></li>
          <li><a href="#">Easy Return Support</a></li>
        </ul>
      </div>

      <!-- Column 4: Delivery -->
      <div class="footer-column">
        <h4>Delivery</h4>
        <ul>
          <li><a href="#">Free Delivery</a></li>
          <li><a href="#">Packaging</a></li>
          <li><a href="#">Store Packaging</a></li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>©Designed by: ‘Ufnity Studio’</p>
      <div class="payment-methods">
        <span>Secured Payment</span>
        <img
          src="@/assets/pic/Discover (2).png"
          alt="Discover"
          class="payment-icon-img"
        />
        <img
          src="@/assets/pic/Master card.png"
          alt="Mastercard"
          class="payment-icon-img"
        />
        <img
          src="@/assets/pic/Paypal (1).png"
          alt="Paypal"
          class="payment-icon-img"
        />
        <img src="@/assets/pic/visa.png" alt="Visa" class="payment-icon-img" />
        <img
          src="@/assets/pic/America express.png"
          alt="American Express"
          class="payment-icon-img"
        />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style scoped>
/* محاذاة كل المحتوى داخل أعمدة الفوتر إلى اليسار */
.footer-column {
  text-align: left;
  align-items: flex-start; /* لمحاذاة العناصر لليسار إذا كان العمود يستخدم flexbox */
}

/* إزالة الحشوة الافتراضية من القوائم لمحاذاة العناصر مع العناوين */
.footer-column ul {
  padding-left: 0;
  list-style: none; /* إزالة النقاط من القائمة */
}
</style>
